<template>
    <div class="container-fluid p-1 h-100" >
        <div class="card widget-card border-light shadow-sm text-dark h-100" :style="_styleBg">
            <div class="card-body py-1">
                <div class="row ">
                  <div class="col-8 ">
                    <h6 class="card-title widget-card-title mb-2">{{dataCaption}}</h6>
                    <h4 class="card-subtitle text-body-secondary m-0" v-if="dataDecimal===0">{{numeralFormat(dataValue, '0,0')}}</h4>
                    <h4 class="card-subtitle text-body-secondary m-0" v-if="dataDecimal===1">{{numeralFormat(dataValue, '0,0[.]0')}}</h4>
                    <h4 class="card-subtitle text-body-secondary m-0" v-if="dataDecimal===2">{{numeralFormat(dataValue, '0,0[.]00')}}</h4>
                  </div>
                  <div class="col-4">
                    <div class="d-flex justify-content-end">
                      <div v-if="dataIcon==99" class="lh-1 text-primary bg-white border border-2 border-primary rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-files-o fs-4 text-primary" ></i>
                      </div>
                      <div v-if="dataIcon==0" class="lh-1 text-info bg-white border border-2 border-info rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-file-o fs-6 text-info" ></i>
                      </div>
                      <div v-if="dataIcon==1" class="lh-1 text-warning bg-white border border-2 border-warning rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-stethoscope fs-6 text-warning"></i>
                      </div>
                      <div v-if="dataIcon==2" class="lh-1 text-warning bg-white border border-2 border-warning rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-pencil fs-6 text-warning" ></i>
                      </div>
                      <div v-if="dataIcon==3" class="lh-1 text-success bg-white border border-2 border-success rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-check fs-6 text-success" ></i>
                      </div>
                      <div v-if="dataIcon==4" class="lh-1 text-danger bg-white border border-2 border-danger rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-close fs-4 text-danger"></i>
                      </div>
                      <div v-if="dataIcon==10" class="lh-1 text-success bg-white border border-2 border-success rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-btc fs-4 text-success" ></i>
                      </div>
                      <div v-if="dataIcon==11" class="lh-1 text-success bg-white border border-2 border-success rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-money fs-4 text-success" ></i>
                      </div>
                      <div v-if="dataIcon==20" class="lh-1 text-primary bg-white border border-2 border-primary rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-hospital-o fs-4 text-primary" ></i>
                      </div>
                      <div v-if="dataIcon==21" class="lh-1 text-primary bg-white border border-2 border-primary rounded-circle p-2 d-flex align-items-center justify-content-center">
                        <i class="fa fa-vcard-o fs-4 text-primary" ></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-12">
                    <div class="d-flex align-items-center mt-2">
                      <span class="lh-1 mx-2 bg-danger-subtle text-secondary rounded-circle p-1 d-flex align-items-center justify-content-center">
                        <i class="fa fa-file-text"></i>
                      </span>
                      <div class="">
                        <span class="mb-0 text-secondary" style="font-size:80%;">{{dataRemark}}</span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'RepDshCard',
  components: {

  },
  data () {
    return {

    }
  },
  computed: {
    _styleBg () {
      if (this.dataBgColor === '') {
        return 'background: white;'
      } else {
        return 'background:' + this.dataBgColor
      }
    }
  },
  props: ['dataCaption', 'dataValue', 'dataDecimal', 'dataIcon', 'dataRemark', 'dataBgColor'],
  mounted () {

  },
  methods: {

  }
}
</script>

<style>

</style>
